<template>
  <div>

    <!--  top-banner-->
    <div
        :style="$vuetify.breakpoint.mdAndUp?'height: 600px':null"
        style="position: relative; width: 100vw">
      <loading v-if="loading"/>

      <v-img
          v-else
          width="100%"
          height="100%"
          :src="banner.file"></v-img>
      <div class="faq-header-bottom-border">
        <img width="100%"
             height="100%"
             src="@/assets/images/vBorder.png" alt="border">
      </div>
    </div>
    <!--  about-details-->
    <about-deatils/>
    <!--  FAQ-->
<!--    <FAQ :about-questions-lists="aboutQuestionsLists"/>-->
<!--    &lt;!&ndash;    join-our&ndash;&gt;-->
<!--    <section class="pb-16 pt-16 text-center">-->
<!--      <h1 class="pt-10">{{ $t('join-team') }}</h1>-->
<!--      <h5 class="pt-6">{{ $t('join-team-content') }}</h5>-->
<!--      <v-btn class="mt-6" color="warning" x-large depressed>-->
<!--        <h5 class="font-weight-bold black&#45;&#45;text">{{ $t('join-team-btn') }}</h5>-->
<!--      </v-btn>-->
<!--    </section>-->
    <!--    team-->
<!--    <team/>-->
<!--&lt;!&ndash;    partners&ndash;&gt;-->
<!--    <partners/>-->
<!--&lt;!&ndash;    awards&ndash;&gt;-->
<!--    <awards/>-->
  </div>
</template>

<script>
import AboutDeatils from "./components/aboutDeatils";
import FAQ from "./components/FAQ";
import Team from "./components/team";
import Partners from "./components/partners";
import Awards from "./components/awards";
import {
  GET_ABOUT_COMPANY,
  GET_ABOUT_COMPANY_BANNER,
  GET_CERTIFICATES
} from "../../../store/aboutManagement/action_type";
import {mapState} from "vuex";

export default {
  name: "aboutArdakan",
  components: {Awards, Partners, Team, FAQ, AboutDeatils},
  data() {
    return {
      aboutQuestionsLists: [
        {
          id: 1,
          question: 'Has SageGlass technology been tested by an independent body? What is its level of durability?',
          answer: ' La technologie SageGlass a subi des essais de performance et de durabilité extrêmement rigoureux, réalisés par des organismes externes indépendants comme le Département de l’Énergie des États-Unis et les leaders de l’industrie de la fabrication du verre et verrières. Les vitrages isolants SageGlass ont été les premiers produits à obtenir la certification ASTM E-2141-06 (Méthodes d’essai standard pour l’évaluation de la durabilité des revêtements électrochromes absorbants sur les vitrages isolants étanches).\n' +
              'La technologie SageGlass a résisté à plus de 100 000 cycles d’essais accélérés de durabilité environnementale, soit le double des standards d’essais, ce qui reviendrait à actionner une fenêtre neuf fois par jour, 365 jours par an, pendant 30 ans, selon le National Renewable Energy Laboratory du Département de l’Énergie.'
        },
        {
          id: 2,
          question: '',
          answer: ''
        },
        {
          id: 3,
          question: '',
          answer: ''
        },
        {
          id: 4,
          question: '',
          answer: ''
        },
        {
          id: 5,
          question: '',
          answer: ''
        },

      ]
    }
  },
  created() {
    this.$store.dispatch(`aboutManagement/${GET_ABOUT_COMPANY_BANNER}`);
  },
  computed: {
    ...mapState({
      banner: state => state.aboutManagement.aboutCompanyBanner,
      loading: state => state.aboutManagement.loading,
    })
  }
}
</script>

<style scoped>
.banner {
  background: #2d5eb5;
  height: 400px;
}
.faq-header-bottom-border {
  position: absolute;
  bottom: -9px;
  width: 100%;
  z-index: 2;
}
</style>